module.exports = __webpack_public_path__ + "img/19e598909b85ef70b7172dd965836132.png";